


const INITIAL_STATE = {
    consultant: null,
  };


  export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "read_filter":
            return { ...state
            };
        case "update_filter":
            return { ...state,
                consultant:action.payload
            };
        default:
            return { ...state
            }
    }

}